module.exports = __webpack_public_path__ + "static/media/mandrake.b9b9b1da.png";